import Button, { ButtonProps } from "./Button";
import Icon, { IconProps } from "../Icon";
import classes from "../../styles/Buttons.module.css";
import { getClasses } from "../../utils";

export type IconButtonProps = IconProps & ButtonProps & { name?: string };

const IconButton: React.FC<IconButtonProps> = (props) => {
  const animations = {
    click: {
      duration: 0.25,
      main: classes["icon-click"],
    },
  };

  return (
    <Button
      {...props}
      disabled={props.disabled}
      className={getClasses(classes, "control", "icon")}
      animations={animations}
      name={props.name ?? `icon-btn-${(Math.random() * 1000).toFixed(0)}`}
    >
      <div className={classes["click-effect"]}>
        <Icon type={props.type} size={props.size} className={props.className} color={props.color} />
      </div>
    </Button>
  );
};

export default IconButton;
